import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '../lib/api.js';
import { useLang } from '../lib/i18n.js';
import { PageHead, Stat } from '../components/ui.js';
import { Icon } from '../components/Icon.js';

interface Analytics { stats?: { dm_sent?: number; total?: number } }
interface CreditBalance { total_remaining: number }

export function Overview() {
  const { user } = useUser();
  const navigate = useNavigate();
  const api = useApi();
  const { t } = useLang();

  const { data: credits } = useQuery({
    queryKey: ['credit-pill'],
    queryFn: () => api.get<CreditBalance>('/credits'),
    retry: false,
  });
  const { data: social } = useQuery({
    queryKey: ['social-posts-analytics'],
    queryFn: () => api.get<Analytics>('/social-posts/analytics'),
    retry: false,
  });

  const firstName = (user?.firstName || user?.fullName || '').split(' ')[0];

  return (
    <div className="wrap section-gap">
      <PageHead
        title={`${t('page.overview.welcome')}${firstName ? ', ' + firstName : ''}`}
        sub={t('page.overview.sub')}
        actions={<button className="btn btn--primary" onClick={() => navigate('/sandbox')}><Icon name="sparkles" />{t('nav.sandbox')}</button>}
      />

      <div className="stats">
        <Stat icon="bolt" label={t('side.creditpill')} value={(credits?.total_remaining ?? 0).toLocaleString('en-US')} />
        <Stat icon="megaphone" label={t('page.social.stat.comments')} value={(social?.stats?.total ?? 0).toLocaleString('en-US')} />
        <Stat icon="inbox" label={t('page.social.stat.dms')} value={(social?.stats?.dm_sent ?? 0).toLocaleString('en-US')} />
      </div>

      <div className="card card--pad">
        <div className="between wrapf">
          <div className="flex aic gap16">
            <div className="stat__icon" style={{ width: 44, height: 44, background: 'var(--accent-soft)' }}><Icon name="checkcircle" /></div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{t('page.overview.aiactive')}</div>
            </div>
          </div>
          <button className="btn btn--ghost btn--sm" onClick={() => navigate('/channels')}>{t('page.overview.quick.channels')}</button>
        </div>
      </div>

      <div className="grid3">
        {[
          { icon: 'box',      t: t('page.overview.quick.products'), r: '/products' },
          { icon: 'plug',     t: t('page.overview.quick.channels'), r: '/channels' },
          { icon: 'sparkles', t: t('nav.sandbox'),                  r: '/sandbox' },
        ].map((q) => (
          <button key={q.r} className="card card--pad" style={{ textAlign: 'start', cursor: 'pointer' }} onClick={() => navigate(q.r)}>
            <div className="stat__icon" style={{ width: 40, height: 40, marginBottom: 12 }}><Icon name={q.icon} /></div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{q.t}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
